export const FeedBillConstants = {
    form: {
        title: {
            create: 'New Feed Bill',
            edit: 'Edit Feed Bill',
        },
        header: {
            invoice: {
                label: 'Invoice #',
                success: 'Looks Good!',
                error: 'Please provide invoice number',
            },
            feedlot: {
                label: 'Feedlot:',
                success: 'Looks Good!',
                error: 'Please select a feedlot',
            },
            date: {
                label: 'Date:',
                success: 'Looks Good!',
                error: 'Please select a feed bill date',
            },
            feedBillTemplate: {
                label: 'Feed Bill Template:',
                success: 'Looks Good!',
                error: 'Please select a template',
            },
        },
        heading: {
            lot: 'Lot',
            feed: 'Feed',
            medsAndProcessing: 'Meds/Processing',
            brandsAndHealth: 'Brands/Health',
            freight: 'Freight',
            deads: 'Deads',
            subTotal: 'Subtotal',
        },
        footer: {
            total: 'Total',
            button: {
                delete: 'Delete',
                save: 'Save',
                goback: 'Go Back',
            },
            confirmDelete: 'Are you sure you want to delete FeedBill',
        },
        button: {
            saveAllLineItems: 'Save All Line Items',
            submit: 'Submit',
            addRow: ' Add Row',
        },
        status: {
            success: 'Submitted Successfully!',
        },
    },
    list: {
        heading: {
            lot: 'Lot',
            feed: 'Feed',
            medsAndProcessing: 'Meds/Processing',
            brandsAndHealth: 'Brands/Health',
            freight: 'Freight',
            deads: 'Deads',
            entryTotal: 'Entry Total',
            billEntries: 'Bill Entries',
            invoice: 'Invoice #',
            feedlot: 'Feedlot',
            billDate: 'Bill Date',
            billTotal: 'Bill Total',
        },
        filter: {
            labels: {
                invoice: 'Invoice',
                feedLot: 'Feedlot',
                endDate: 'End Date',
                startDate: 'Start Date',
            },
            placeHolder: {
                invoiceNumber: 'Invoice Number',
                feedLot: 'Feedlot',
            },
            button: {
                clear: 'Clear Filters',
            },
        },
    },

    confirmModal: {
        title: 'Changes have been made but not saved',
        message:
            'Your recent work may not have been saved. If you want to save your work, go back and save before leaving this screen',
        Button: {
            continue: 'Continue Without Saving',
            back: 'Go Back',
        },
    },

    searchValue: /[^a-zA-Z0-9/. -]/g,
    replaceValue: '',
    useBlankFeedBill: 'Use Blank Feed Bill',
    inComplete: 'InComplete',
    draft: '(Draft)',
    dateSelectionErrorMessage:
        'Select StartDate and EndDate to generate reports',
    report: {
        title: 'Feed Bill Owner Data',
        dateFrom: 'From',
        dateTo: 'To',
        button: {
            download: 'Download Report',
            generateReport: 'Generate Report',
        },
        selectOwner: 'Please select an Owner from the top',
    },
    selectLot: 'Select a Lot',
    selectFeedlot: 'Select a Feedlot',
};
